import { H2, P } from "@/lib/styles";
import styled from "styled-components";

export const Container = styled.div`
  &:first-child {
    margin-top: 4rem;
  }
  &:not(:last-child) {
    margin-bottom: 3.75rem;
    ${({ theme }) => theme.mediaQueries.laptop} {
      margin-bottom: 5rem;
    }
  }
  color: ${({ theme }) => theme.colors.middleGrey};
  opacity: 0;
  transform: translateY(20px);
`;
export const Heading = styled(H2)`
  ${({ theme }) => theme.mediaQueries.laptop} {
    margin-bottom: 0.5rem;
  }
`;
export const Paragraph = styled(P)``;
